__turbopack_context__.v({
  "categorySuggestionText": "styles-module__eOWJCq__categorySuggestionText",
  "lensIcon": "styles-module__eOWJCq__lensIcon",
  "searchSuggestion": "styles-module__eOWJCq__searchSuggestion",
  "searchSuggestionText": "styles-module__eOWJCq__searchSuggestionText",
  "searchSuggestionTextVariant": "styles-module__eOWJCq__searchSuggestionTextVariant",
  "searchSuggestionVariantA": "styles-module__eOWJCq__searchSuggestionVariantA",
  "searchSuggestionVariantB": "styles-module__eOWJCq__searchSuggestionVariantB",
  "suggestionList": "styles-module__eOWJCq__suggestionList",
  "textWithEllipsis": "styles-module__eOWJCq__textWithEllipsis",
  "wrapper": "styles-module__eOWJCq__wrapper",
});
